export default "__VITE_ASSET__fe47851b__"